<template>
  <BaseStack
    :class="[$b(), { 'has-hover': hasHover }]"
    v-bind="$attrs"
    :has-media="hasMedia"
    :full-height="fullHeight"
  >
    <template
      v-if="hasMedia"
      #media
    >
      <component
        :is="cta.active && !$attrs.link ? 'BaseLink' : 'div'"
        :to="cta.active && !$attrs.link ? cta.link : null"
        :class="$b('media-outer')"
      >
        <div :class="$b('media-inner')">
          <DynamicImage
            v-if="hasMedia"
            :class="['StackRow__media', { 'StackRow__media--full-height': fullHeight }]"
            :image="media"
            :aspect-ratio="aspectRatio"
          />
        </div>
      </component>
    </template>

    <template
      v-if="subtitle"
      #subtitle
    >
      <BaseHeading
        v-if="subtitle"
        :class="$b('subtitle')"
        tag="h5"
        size="h5"
      >
        {{ $tr(subtitle) }}
      </BaseHeading>
    </template>

    <template
      v-if="heading.text"
      #heading
    >
      <BaseHeading
        v-if="heading.text"
        :class="$b('heading')"
        :tag="heading.tag || 'h3'"
        :size="headingSize"
      >
        {{ $tr(heading.text) }}
      </BaseHeading>
    </template>

    <template
      v-if="copy.text"
      #copy
    >
      <RichText
        v-if="copy.text"
        :class="[$b('copy'), copy.size === 'large' ? 't-h3' : 't-body']"
        :content="copy.text"
      />
    </template>

    <template
      v-if="cta.active && !$attrs.link"
      #controls
    >
      <SecondaryLineLink
        v-if="cta.type === 'link'"
        size="regular"
        :to="cta.link"
        @mouseover="hasHoverOn"
        @mouseleave="hasHoverOff"
      >
        {{ $tr(cta.copy) }}
      </SecondaryLineLink>
      <component
        :is="cta.style"
        v-else
        :class="$b('button')"
        size="small"
        :to="cta.link"
        @mouseover="hasHoverOn"
        @mouseleave="hasHoverOff"
      >
        {{ $tr(cta.copy) }}
      </component>
    </template>
  </BaseStack>
</template>

<script>
import aspectRatio from '~/assets/js/constants/aspectRatio'
import headingMixin from '~/mixins/headingMixin'

import {
  BaseLink
} from '#components'

export default {
  name: 'StackRow',

  components: {
    BaseLink
  },

  mixins: [headingMixin],

  props: {
    media: {
      type: Object,
      default: () => {}
    },

    aspectRatio: {
      type: String,
      default: '16:9',
      validator: value => aspectRatio.includes(value)
    },

    fullHeight: {
      type: Boolean,
      default: false
    },

    subtitle: {
      type: String,
      default: ''
    },

    copy: {
      type: Object,
      default: () => {}
    },

    copySize: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return [
          'regular',
          'large'
        ].includes(value)
      }
    },

    cta: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      hasHover: false
    }
  },

  computed: {
    hasMedia () {
      return this.media && !!this.media.src
    }
  },

  methods: {
    hasHoverOn () {
      this.hasHover = true
    },

    hasHoverOff () {
      this.hasHover = false
    }
  }
}
</script>

<style lang="postcss">
.StackRow__media-outer {
  @apply h-full;
  display: block;
}

.StackRow__media-inner {
  @apply h-full;
  transform: scale(1) translateZ(0);
  transition: transform 0.5s ease;

  a:hover &,
  .Stack.has-hover & {
    transform: scale(1.025) translateZ(0);
  }
}

.StackRow__media.StackRow__media--full-height {
  @apply w-full h-full object-cover;
}

.StackRow__subtitle {
  opacity: 0.4;
}

.StackRow__button {
  @apply mt-[20px] mb-[30px];

  @screen md {
    @apply mb-0;
  }
}
</style>
